"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var lodash_1 = require("lodash");
var rc_table_1 = __importDefault(require("rc-table"));
var react_2 = __importStar(require("react"));
var icons_1 = require("../../../icons");
var style_1 = require("../../../style");
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var input_1 = require("../../input");
var layout_1 = require("../../layout");
var EmptyState_1 = __importDefault(require("../EmptyState"));
var Cell_1 = __importDefault(require("./Cell"));
var CollapseIcon_1 = __importDefault(require("./icons/CollapseIcon"));
var ExpandIcon_1 = __importDefault(require("./icons/ExpandIcon"));
var TableBarCell_1 = __importDefault(require("./TableBarCell"));
var styles_1 = __importStar(require("./styles"));
var ResizableHeader_1 = __importDefault(require("./components/ResizableHeader"));
var SortIcon_1 = __importDefault(require("./icons/SortIcon"));
var utils_1 = require("./utils");
var Dropdown_1 = __importDefault(require("../../Dropdown"));
var Skeleton_1 = __importDefault(require("../../Skeleton"));
var constant_1 = require("../../Skeleton/constant");
var DEFAULT_RENDER_LOADING = function () { return react_1.jsx(Skeleton_1.default, { variant: constant_1.SkeletonVariant.TEXT, animate: false }); };
function getDefaultAlignment(dataType) {
    if (dataType === void 0) { dataType = 'string'; }
    var dataTypeToAlignment = {
        string: 'left',
        boolean: 'center',
        number: 'right',
        date: 'right',
    };
    return lodash_1.get(dataTypeToAlignment, dataType, 'left');
}
var FilterIcon = function (_a) {
    var filtered = _a.filtered, menu = _a.menu, name = _a.name, onClick = _a.onClick;
    var icon = (react_1.jsx(icons_1.FilterFunnel, { css: styles_1.default.filter, "data-6si-name": name, color: filtered ? style_1.DesignSystemColor.Blue.DEFAULT : style_1.DesignSystemColor.Gray.LIGHT_1, onClick: onClick }));
    if (menu) {
        return (react_1.jsx(Dropdown_1.default, { menu: menu }, icon));
    }
    return icon;
};
var getExpandIconConf = function (isTreeData) {
    if (isTreeData === void 0) { isTreeData = false; }
    return ({
        expandIcon: function (_a) {
            var expanded = _a.expanded, onExpand = _a.onExpand, record = _a.record, _b = _a.expandable, expandable = _b === void 0 ? true : _b;
            if (!record.children && isTreeData) {
                return (react_1.jsx("span", { css: react_1.css({
                        display: 'inline-block',
                        width: 40,
                        height: 'auto',
                    }) }));
            }
            var props = {
                css: styles_1.expandCollapseIconStyles(expandable, isTreeData),
                onClick: expandable ? function (e) { return onExpand(record, e); } : undefined,
            };
            if (expanded) {
                if (isTreeData) {
                    return react_1.jsx(input_1.Button, __assign({ icon: icons_1.ChevronUp }, props, { size: "sm", hierarchy: "tertiary" }));
                }
                return react_1.jsx(CollapseIcon_1.default, __assign({}, props));
            }
            if (isTreeData) {
                return react_1.jsx(input_1.Button, __assign({}, props, { icon: icons_1.ChevronDown, size: "sm", hierarchy: "tertiary" }));
            }
            return react_1.jsx(ExpandIcon_1.default, __assign({}, props));
        },
    });
};
function Table(_a) {
    var _b;
    var children = _a.children, className = _a.className, data = _a.data, _c = _a.emptyDescription, emptyDescription = _c === void 0 ? '' : _c, _d = _a.emptyIllustration, emptyIllustration = _d === void 0 ? 'NoData' : _d, _e = _a.emptyTitle, emptyTitle = _e === void 0 ? '' : _e, onSelect = _a.onSelect, rowKey = _a.rowKey, selected = _a.selected, size = _a.size, totalDatasetSize = _a.totalDatasetSize, _f = _a.sticky, sticky = _f === void 0 ? false : _f, scroll = _a.scroll, expandable = _a.expandable, _g = _a.bordered, bordered = _g === void 0 ? true : _g, _h = _a.rounded, rounded = _h === void 0 ? true : _h, _j = _a.dividers, dividers = _j === void 0 ? true : _j, _k = _a.indentSize, indentSize = _k === void 0 ? 24 : _k, loading = _a.loading, _l = _a.loadingRowCount, loadingRowCount = _l === void 0 ? 5 : _l, _m = _a.showHeader, showHeader = _m === void 0 ? true : _m, onRowClick = _a.onRowClick;
    var _o = react_2.useState({}), columnWidths = _o[0], setColumnWidths = _o[1];
    var _p = react_2.useState(), activeResizingColumn = _p[0], setActiveResizingColumn = _p[1];
    var isSelectMode = Boolean(selected);
    var hasTreeData = lodash_1.some(data, function (d) { return lodash_1.has(d, 'children'); });
    var _q = react_2.useState(undefined), sortField = _q[0], setSortField = _q[1];
    var _r = react_2.useState('asc'), sortOrder = _r[0], setSortOrder = _r[1];
    var defaultExpandIconColumnIndex = isSelectMode ? 1 : 0;
    var expandIconColumnIndex = lodash_1.isFinite(expandable === null || expandable === void 0 ? void 0 : expandable.expandIconColumnIndex)
        ? (expandable === null || expandable === void 0 ? void 0 : expandable.expandIconColumnIndex) || defaultExpandIconColumnIndex
        : defaultExpandIconColumnIndex;
    var rcTableStyles = react_2.useMemo(function () { return styles_1.getRcTableStyle(size, bordered, rounded, dividers); }, [size, bordered, rounded, dividers]);
    var sortedTable = react_2.useMemo(function () {
        var sorted = data;
        if (sortField) {
            sorted = __spreadArrays(data).sort(function (a, b) {
                var _a;
                return ((_a = JSON.stringify(lodash_1.get(a, sortField))) === null || _a === void 0 ? void 0 : _a.localeCompare(JSON.stringify(lodash_1.get(b, sortField)), 'en', {
                    numeric: true,
                })) * (sortOrder === 'asc' ? 1 : -1);
            });
        }
        return sorted;
    }, [sortField, sortOrder, data]);
    var handleSortingChange = function (accessor) {
        var newSortOrder = accessor === sortField && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortField(accessor);
        setSortOrder(newSortOrder);
    };
    var handleSortingFunction = function (accessor, sortOptions) {
        var newSortOrder = sortOptions.sortOrder === 'asc' ? 'desc' : 'asc';
        sortOptions.sortFunc(accessor, newSortOrder);
    };
    var getSortDirection = function (sortOptions) {
        if (sortOptions && sortOptions.sortOrder) {
            return sortOptions.sortOrder;
        }
        else {
            return sortOrder;
        }
    };
    var renderHeaderCell = function (props) {
        var header = props.header, align = props.align, _a = props.dataType, dataType = _a === void 0 ? 'string' : _a, sortOptions = props.sortOptions, sortKey = props.sortKey, sortDataName = props.sortDataName, help = props.help, filter = props.filter, filterMenu = props.filterMenu, filterDataName = props.filterDataName, _b = props.onFilterClick, onFilterClick = _b === void 0 ? function () { return ({}); } : _b;
        var sortDirection = getSortDirection(sortOptions);
        var isASC = sortDirection === 'asc' &&
            (sortField === sortKey || (sortOptions && sortOptions.sortField === sortKey));
        var isDESC = sortDirection === 'desc' &&
            (sortField === sortKey || (sortOptions && sortOptions.sortField === sortKey));
        var activeSortingOrder = isASC ? 'ASC' : isDESC ? 'DESC' : undefined;
        var cellAlignment = align || utils_1.getCellAlignment(dataType);
        var justify = utils_1.getHeaderJustify(cellAlignment);
        return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: justify },
            react_1.jsx(layout_1.Flex, { alignItems: "center", css: react_1.css({
                    flexGrow: justify === 'flex-start' ? 1 : undefined,
                }) },
                react_1.jsx("span", null, header),
                help && (react_1.jsx(Tooltip_1.default, { overlay: help, css: styles_1.default.help },
                    react_1.jsx(icons_1.HelpCircle, { size: 16, color: style_1.DesignSystemColor.Gray.LIGHT_1 }))),
                sortKey && (react_1.jsx("span", { onClick: sortOptions
                        ? function () { return handleSortingFunction(sortKey, sortOptions); }
                        : function () { return handleSortingChange(sortKey); }, css: styles_1.default.sortIcon, "data-6si-name": sortDataName },
                    react_1.jsx(SortIcon_1.default, { activeSortOrder: activeSortingOrder })))),
            filter !== undefined && (react_1.jsx(FilterIcon, { filtered: filter, menu: filterMenu, name: filterDataName, onClick: onFilterClick }))));
    };
    var handleOnSelect = function (id) {
        if (!selected) {
            return;
        }
        var nextSelected = new Set(selected);
        if (nextSelected.has(id)) {
            nextSelected.delete(id);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(nextSelected, false);
        }
        else {
            nextSelected.add(id);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(nextSelected, false);
        }
    };
    var handleOnSelectAll = function (checked) {
        if (checked) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(new Set(data.map(rowKey)), true);
        }
        else {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(new Set(), true);
        }
    };
    var renderCheckbox = function (rowData) {
        var id = rowKey === null || rowKey === void 0 ? void 0 : rowKey(rowData);
        return (react_1.jsx(layout_1.Flex, { onClick: function (e) { return e.stopPropagation(); }, alignItems: "center", justifyContent: "center" },
            react_1.jsx(input_1.Checkbox, { label: "", checked: Boolean(selected === null || selected === void 0 ? void 0 : selected.has(id)), onChange: function () { return handleOnSelect(id); }, indeterminate: false, disabled: loading })));
    };
    react_2.useEffect(function () {
        var _a;
        var initialColumnWidths = (_a = react_2.default.Children) === null || _a === void 0 ? void 0 : _a.map(children || [], function (child) {
            var _a = child.props, dataKey = _a.dataKey, width = _a.width;
            if (dataKey) {
                return [dataKey, width];
            }
            return [];
        });
        setColumnWidths(Object.fromEntries(lodash_1.chunk(initialColumnWidths, 2)));
    }, [children]);
    var hasFixedColumns = false;
    var columnIndexToReducePL = isSelectMode ? expandIconColumnIndex - 1 : expandIconColumnIndex;
    var columns = (_b = react_2.default.Children) === null || _b === void 0 ? void 0 : _b.map(children || [], function (child, index) {
        var _a = child.props, field = _a.header, dataIndex = _a.dataKey, ellipsis = _a.ellipsis, fixed = _a.fixed, _b = _a.resizable, resizable = _b === void 0 ? false : _b, sortKey = _a.sortKey, sortOptions = _a.sortOptions, width = _a.width, minWidth = _a.minWidth, maxWidth = _a.maxWidth, _c = _a.align, align = _c === void 0 ? getDefaultAlignment(child.props.dataType) : _c;
        var columnWidth = lodash_1.get(columnWidths, [dataIndex], width);
        hasFixedColumns = hasFixedColumns || ['left', 'right'].includes(fixed);
        var shouldReducePL = hasTreeData && index === columnIndexToReducePL;
        var colConf = {
            field: field,
            dataIndex: dataIndex,
            ellipsis: ellipsis,
            align: align,
            className: shouldReducePL ? 'pl-8' : undefined,
            // To force fix the first column so that expand icon doesn't move left on h-scroll
            fixed: index === 0 && !isSelectMode && expandable ? 'left' : fixed,
            width: columnWidth,
            title: renderHeaderCell(child.props),
            onCell: function () { return ({
                className: dataIndex && dataIndex === activeResizingColumn ? 'resizing' : undefined,
            }); },
            onHeaderCell: function () {
                var isSorted = (sortField && sortField === sortKey) ||
                    (sortOptions && sortOptions.sortField === sortKey);
                var common = {
                    className: isSorted ? 'sorted' : '',
                };
                if (resizable && dataIndex && width) {
                    return __assign(__assign({}, common), { minWidth: minWidth,
                        maxWidth: maxWidth, width: columnWidth, onResize: function (e, _a) {
                            var resizedSized = _a.size;
                            if (lodash_1.has(columnWidths, dataIndex)) {
                                setActiveResizingColumn(dataIndex);
                                setColumnWidths(function (prev) {
                                    var _a;
                                    return (__assign(__assign({}, prev), (_a = {}, _a[dataIndex] = resizedSized.width, _a)));
                                });
                            }
                        }, onResizeStop: function () {
                            setActiveResizingColumn(undefined);
                        } });
                }
                else {
                    return common;
                }
            },
        };
        if (typeof child.props.children === 'function') {
            colConf.render = loading ? (child.props.renderLoading || DEFAULT_RENDER_LOADING) : function (cellValue, rw, i) {
                var _a;
                var childToReturn = child.props.children({
                    data: rw,
                    size: size,
                    index: i,
                });
                if ((childToReturn === null || childToReturn === void 0 ? void 0 : childToReturn.type) === TableBarCell_1.default) {
                    return childToReturn;
                }
                return (_a = childToReturn === null || childToReturn === void 0 ? void 0 : childToReturn.props) === null || _a === void 0 ? void 0 : _a.children;
            };
        }
        return colConf;
    });
    if (isSelectMode) {
        var allChecked = Boolean(data.length && (selected === null || selected === void 0 ? void 0 : selected.size) === (totalDatasetSize || data.length));
        columns.unshift({
            dataIndex: '',
            width: 60,
            fixed: 'left',
            title: (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center" },
                react_1.jsx(input_1.Checkbox, { label: "", checked: allChecked, onChange: handleOnSelectAll, indeterminate: Boolean(selected === null || selected === void 0 ? void 0 : selected.size) && !allChecked, disabled: loading }))),
            render: function (rowData) { return renderCheckbox(rowData); },
            field: undefined,
        });
    }
    var calculatedScroll = scroll;
    var shouldHaveScrollX = hasFixedColumns || !!selected;
    if (shouldHaveScrollX && !(scroll === null || scroll === void 0 ? void 0 : scroll.x)) {
        calculatedScroll = lodash_1.assign({ x: '100.1%' }, scroll);
    }
    if (sticky && !(scroll === null || scroll === void 0 ? void 0 : scroll.y)) {
        calculatedScroll = lodash_1.assign({ y: true }, calculatedScroll);
        console.warn("Incorrect Sticky Table Usage:\n     When Sticky is true, you must pass scroll.y with a number");
    }
    var loadingData = react_2.useMemo(function () { return (new Array(loadingRowCount).fill(null).map(function (_, i) { return ({ id: i }); })); }, [loadingRowCount]);
    return (react_1.jsx(react_2.Fragment, null,
        react_1.jsx(react_1.Global, { styles: rcTableStyles }),
        react_1.jsx(rc_table_1.default, { showHeader: showHeader, indentSize: indentSize, onRow: onRowClick ? function (row, index) { return ({
                onClick: function () { return onRowClick(row, index || 0); },
            }); } : undefined, components: {
                header: {
                    cell: ResizableHeader_1.default,
                },
            }, className: className, expandable: lodash_1.merge({
                expandIconColumnIndex: expandIconColumnIndex,
            }, expandable, getExpandIconConf(hasTreeData)), emptyText: react_1.jsx(EmptyState_1.default, { level: { illustration: emptyIllustration, position: 'center' }, title: emptyTitle, description: emptyDescription }), rowKey: loading ? function (r) { return r.id; } : function (record) { return rowKey(record); }, rowClassName: function (rowData) { return ((selected === null || selected === void 0 ? void 0 : selected.has(rowKey(rowData))) ? 'record-selected' : ''); }, data: loading ? loadingData : sortedTable, columns: columns, scroll: calculatedScroll, sticky: sticky })));
}
function Column(props) {
    return props ? null : null; // fix no-unused-vars
}
exports.default = Object.assign(Table, { Column: Column, Cell: Cell_1.default, BarCell: TableBarCell_1.default });
